// extracted by mini-css-extract-plugin
export default {"wrapper":"GameLobbyBoard_wrapper__CDQfh"};